/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1Dependency } from '../models/Campaignservicev1Dependency';
import { Campaignservicev1Miscellanea } from '../models/Campaignservicev1Miscellanea';
import { Campaignservicev1SystemStat } from '../models/Campaignservicev1SystemStat';
import { HttpFile } from '../http/http';

export class Campaignservicev1Checks {
    'systemStat'?: Campaignservicev1SystemStat;
    'dependencies'?: Array<Campaignservicev1Dependency>;
    'miscellaneous'?: Array<Campaignservicev1Miscellanea>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "systemStat",
            "baseName": "systemStat",
            "type": "Campaignservicev1SystemStat",
            "format": ""
        },
        {
            "name": "dependencies",
            "baseName": "dependencies",
            "type": "Array<Campaignservicev1Dependency>",
            "format": ""
        },
        {
            "name": "miscellaneous",
            "baseName": "miscellaneous",
            "type": "Array<Campaignservicev1Miscellanea>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Campaignservicev1Checks.attributeTypeMap;
    }

    public constructor() {
    }
}

